import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gamepad2, Play, Lock, Trophy } from "lucide-react";
import api from "../lib/api";
import { AffiliateCard } from "../components/AffiliateCard";

export default function PtiPlay() {
  const [games, setGames] = useState([]);
  const [gameSeal, setGameSeal] = useState(null);
  const [tops, setTops] = useState({});
  useEffect(() => {
    api.get("/ptiplay").then((r) => {
      setGames(r.data);
      (r.data || []).forEach((g) => {
        api.get(`/arcade/leaderboard/${g.slug}`).then((res) => {
          if (res.data && res.data.length) setTops((p) => ({ ...p, [g.slug]: res.data[0] }));
        }).catch(() => {});
      });
    }).catch(() => {});
    api.get("/affiliate?placement=ptiplay&rotate=true&ab=true").then((r) => setGameSeal(r.data[0] || null)).catch(() => {});
  }, []);

  return (
    <div className="bg-pti-black text-white min-h-[70vh]" data-testid="ptiplay-page">
      <div className="pti-container py-12">
        <header className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[4px] font-bold text-pti-red mb-4"><span className="w-2 h-2 bg-pti-red inline-block" /> Play free · No ads · Self-hosted</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.95] flex flex-col items-center gap-2">
            <span className="flex items-center gap-3"><Gamepad2 className="text-pti-red" size={52} /> PictureThisInk</span>
            <span className="text-pti-red">Arcade</span>
          </h1>
          <p className="text-neutral-400 mt-5 text-base sm:text-lg">Premium free browser games — a Hextris-style puzzle, a tower-defense battle, and a space shooter. No downloads, no ads, no redirects. Just press play.</p>
        </header>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {games.map((g) => {
            const live = g.status === "live";
            const Wrapper = live ? Link : "div";
            return (
              <Wrapper key={g.slug} {...(live ? { to: `/pti-play/${g.slug}` } : {})} data-testid={`game-${g.slug}`}
                className={`group border border-neutral-800 bg-neutral-950 overflow-hidden ${live ? "hover:border-pti-red cursor-pointer" : "opacity-80"} transition-colors block`}>
                <div className="aspect-square overflow-hidden relative bg-white">
                  <img src={g.image} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-2 left-2 text-[10px] uppercase tracking-widest font-bold px-2 py-1 bg-pti-red">{g.category}</div>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-xl font-bold">{g.title}</h3>
                  <p className="text-sm text-neutral-400 mt-1">{g.description}</p>
                  {(() => { const t = tops[g.slug]; return t ? (
                    <div className="mt-3 flex items-center gap-1.5 text-xs font-bold text-pti-red" data-testid={`game-top-${g.slug}`}>
                      <Trophy size={13} /> Top: {t.name} · {t.score}
                    </div>
                  ) : null; })()}
                  <div className="mt-4">
                    {live ? (
                      <span className="inline-flex items-center gap-2 bg-pti-red text-white px-4 py-2 text-sm font-bold"><Play size={14} /> Play now</span>
                    ) : (
                      <span className="inline-flex items-center gap-2 border border-neutral-700 px-4 py-2 text-sm font-bold text-neutral-400"><Lock size={14} /> Coming soon</span>
                    )}
                  </div>
                </div>
              </Wrapper>
            );
          })}
        </div>

        {gameSeal && (
          <div className="mt-16 max-w-md mx-auto" data-testid="ptiplay-affiliate">
            <AffiliateCard ad={gameSeal} placement="ptiplay" className="shadow-lg border-t-4 border-t-pti-red" />
          </div>
        )}

        <footer className="mt-16 border-t border-neutral-800 pt-6 text-center text-xs text-neutral-500 max-w-3xl mx-auto" data-testid="ptiplay-attribution">
          All PictureThisInk Arcade games are free, self-hosted, and ad-free — no external embeds or redirects. Built as original open-source (MIT) implementations, restyled in the PictureThisInk black, white &amp; red palette. Ink Hex is inspired by the open-source Hextris project; Ink Defense and Galaxy Battle are classic arcade genres.
        </footer>
      </div>
    </div>
  );
}
